'use client';

import Image from 'next/image';

import SfLogoMain from '@/assets/icons/sidebar-nav/sportsfi-logo-main';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export default function AuthLoadingScreen({ label = 'Loading' }: { label?: string } = {}): React.ReactNode {
  return (
    <>
      <Image
        src="/images/bg_lights.png"
        alt="SportsFi Background"
        fill
        priority
        className="object-cover brightness-50"
      />

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 text-center text-white">
        <div className="mb-8">
          <SfLogoMain />
        </div>
        <LoadingSpinner size={40} label={label} />
      </div>
    </>
  );
}
